// import lib(s)
/* eslint-disable */
import React, { useEffect, useMemo, useState, useRef } from "react"
import { useDispatch, useSelector } from "react-redux"
import styles from "./SingleLeadView.module.css"

import {selectLead, deselectLead, updateContext, updateGhostBeat, updateGhostIntr, updateMouse, addBeat, addIntr, removeIntr, modifyBeat, updateIntrContext, setScale } from '../AnnotatorSlice'
import FullWidthECGPreview from '../../../components/FullWidthECGPreview';
import * as Lib from '../../../constants/annotator'
import { paintSingleLeadWaveform, xScale, yScale } from '../components/utils/PaintGraph'
import applyInversion from '../../../utils/applyInversion'
import { searchForLocalPeak } from '../../../utils/peakDetection'
import { paintGrid } from '../components/utils/PaintGrid'
import * as d3 from 'd3';
import Beat from '../components/Beat/Beat'
import Interval from '../components/Interval/Interval';
import ContextMenu from '../components/ContextMenu/ContextMenu';
import IntervalContextMenu from '../components/IntervalContextMenu/IntervalContextMenu'
import { getBeatShortcuts } from '../../../utils/beatShortcuts'

import Card from "@mui/material/Card"
import Divider from "@mui/material/Divider"
import Tabs from "@mui/material/Tabs"
import Tab from "@mui/material/Tab"
import Box from "@mui/material/Box"
import CardContent from "@mui/material/CardContent"
import Typography from "@mui/material/Typography"
import Button from "@mui/material/Button"
import Autocomplete from "@mui/material/Autocomplete"
import TextField from "@mui/material/TextField"
import FormLabel from "@mui/material/FormLabel"
import FormControl from "@mui/material/FormControl"
import FormGroup from "@mui/material/FormGroup"
import FormControlLabel from "@mui/material/FormControlLabel"
import FormHelperText from "@mui/material/FormHelperText"
import Checkbox from "@mui/material/Checkbox"
import Switch from "@mui/material/Switch"
import Slider from "@mui/material/Slider"
import Link from "@mui/material/Link"
import List from "@mui/material/List"
import ListItem from "@mui/material/ListItem"
import ListItemButton from "@mui/material/ListItemButton"
import ListItemIcon from "@mui/material/ListItemIcon"
import ListItemText from "@mui/material/ListItemText"
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';

import { useTheme } from '@mui/material/styles';

import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import ZoomOutIcon from '@mui/icons-material/ZoomOut';

const SingleLeadView = (props) => {
    const dispatch = useDispatch()
    const Annotator = useSelector((state) => state.Annotator)
    const settings = useSelector((state) => state.Annotator.settings)
    const inverted = settings.inverted
    const samples = useMemo(
        () => (inverted ? applyInversion(Annotator.filtered.samples) : Annotator.filtered.samples),
        [inverted, Annotator.filtered.samples],
    )
    const ShowContext = useSelector((state) => state.Annotator.context.show)
    const ShowIntervalContext = useSelector((state) => state.Annotator.intrervalMenu.show)
    const ContextData = useSelector((state) => state.Annotator.context.data)
    const isCompleted = false
    // useSelector((state) => state.Annotator.recordingInfo.annotation.inbox) === 4
    const [Height, setHeight] = useState(925)
    const [Width, setWidth] = useState(1150)

    // logic for filters:
    const [filters, setFilters] = React.useState([]);
    const filterList = [
        'Adaptive',
        'Highpass - 0.1 Hz',
        'Highpass - 0.2 Hz',
        'Highpass - 0.5 Hz',
        'Lowpass - 40 Hz',
        'Lowpass - 50 Hz',
        'Lowpass - 100 Hz',
    ];
    

    const handleFilterChange = (event) => {
        const {
        target: { value },
        } = event;
        setFilters(
        // On autofill we get a stringified value.
        typeof value === 'string' ? value.split(',') : value,
        );
    };


    const [ windowSize, SetWindowSize ] = useState({
        width: window.innerWidth,
        height: window.innerHeight,
    })

    const handleWindowResize = () => {
        console.log("Window Resized");
        SetWindowSize({
            width: window.innerWidth,
            height: window.innerHeight,
        });
    }

    const onDeSelectLead = () =>{
        dispatch(deselectLead())
        props.changeTab(0)
    }
    
    const AnnotatorContainer = useRef()
    const AnnotatorCanvas = useRef()

    // === New Component States ===
    const [PageRendered, setPageRendered] = useState(false)

    // === Annotator Constants ===
    // Derived every render from state (Width/Height) + Redux so downstream
    // consumers (Interval render map, mouse handlers, paintGrid) always see
    // real numbers instead of undefined between effect runs.
    const CurrentSample = samples[Annotator.selectedLead] ?? []
    const CurrentSampleLength = CurrentSample.length
    const CanvasWidth = Width
    const CanvasHeight = Height
    const SecondsPerRow = CanvasWidth / Lib.PX_PER_SECOND
    const SamplePerRow = SecondsPerRow * Annotator.filtered.frequency
    const NoOfRows = SamplePerRow > 0 ? Math.ceil(CurrentSampleLength / SamplePerRow) : 0
    const RowHeightPx = Lib.MV_BANDWIDTH * Lib.PX_PER_MV * 2
    const RowWidthPx = CanvasWidth
    const RecordingHeightPx = RowHeightPx * NoOfRows
    const EkgHeight = RecordingHeightPx > CanvasHeight ? RecordingHeightPx : CanvasHeight
    const TotalSeconds = Annotator.filtered.frequency > 0 ? CurrentSampleLength / Annotator.filtered.frequency : 0

    // Total content extent needed to fit the fully-scaled grid + waveform at
     // the current zoom. Used to grow the outer container so .tool2Col2Row's
     // overflow:scroll can scroll horizontally and vertically, matching Row
     // View behavior.
    const RenderedRowHeightPx = Lib.MV_BANDWIDTH * Lib.PX_PER_MV * 2
    const RenderedSecondsPerRow = Width / Lib.PX_PER_SECOND
    const RenderedSamplePerRow = RenderedSecondsPerRow * Annotator.filtered.frequency
    const RenderedNoOfRows = Math.ceil(CurrentSampleLength / RenderedSamplePerRow)
    const ContentHeightPx = RenderedNoOfRows * RenderedRowHeightPx
    const ScaledContentHeightPx = ContentHeightPx * settings.scale
    const ScaledContentWidthPx = Width * settings.scale
    // Use max(unscaled, scaled) so the outer container's minimum size is at
    // least the natural (zoom=1) content extent. Otherwise at zoom < 1 the
    // container shrinks and the parent scroll container hides scrollbars —
    // producing asymmetric behavior where horizontal scroll is available but
    // vertical isn't.
    const MinContainerHeightPx = Math.max(ContentHeightPx, ScaledContentHeightPx)
    const MinContainerWidthPx = Math.max(Width, ScaledContentWidthPx)

    const handleMouseDown = () =>{
        //console.log("Handle Mouse Down EVENT")
    }

    const rightClick = () =>{
        //console.log("Right Click EVENT")
    }

    const canvasBlurFix = (targetWidth, targetHeight) => {
        const canvas = document.getElementById('waveCanvas');
        const ctx = canvas.getContext('2d');
        const devicePixelRatio = window.devicePixelRatio || 1;

        function setCanvasSize() {
        // Use the explicit target size when provided so the canvas backing store
        // is large enough to fit the fully-scaled waveform/grid; otherwise fall
        // back to the parent element's client size.
        const containerWidth = targetWidth || canvas.parentElement.clientWidth;
        const containerHeight = targetHeight || canvas.parentElement.clientHeight;

        // Scale the canvas based on the device pixel ratio
        canvas.width = containerWidth * devicePixelRatio;
        canvas.height = containerHeight * devicePixelRatio;

        // Set the canvas size in CSS to ensure it maintains the correct aspect ratio
        canvas.style.width = containerWidth + 'px';
        canvas.style.height = containerHeight + 'px';

        // Scale the context to match the device pixel ratio
        ctx.scale(devicePixelRatio, devicePixelRatio);
        }

        // The effect that invokes this reruns on windowSize changes (via
        // handleWindowResize) so we don't need a separate resize listener here.
        setCanvasSize();
    }

    // Coordinates relative to the handler's element (e.currentTarget), not the
    // event's actual target. offsetX/offsetY would be relative to a child that
    // absorbs the pointer event (Beat/Interval SVGs) and produce a wrong click
    // position — critical now that peak snapping depends on click-y.
    const eventCoordinate = (e) => {
        const rect = e.currentTarget.getBoundingClientRect()
        return [e.clientX - rect.left, e.clientY - rect.top, e.pageX, e.pageY]
    }

    useEffect(() => {
        setPageRendered(true)
        window.addEventListener("resize", handleWindowResize, false);
        return () => window.removeEventListener("resize", handleWindowResize, false);
    }, [])

    // Keyboard shortcuts: reclassify a beat by pressing its legend label key.
    // Target: right-click-selected beat if the context menu is open, else the last modified beat.
    const contextShow = useSelector(state => state.Annotator.context.show)
    const contextData = useSelector(state => state.Annotator.context.data)
    const lastModifiedBeatIndex = useSelector(state => state.Annotator.lastModifiedBeatIndex)
    const beatLabels = Annotator.annotations.labels.beats
    useEffect(() => {
        const shortcuts = getBeatShortcuts(beatLabels)
        if (shortcuts.length === 0) return
        const shortcutMap = new Map(shortcuts.map(l => [l.slug.toLowerCase(), l.slug]))

        const handleKeyDown = (e) => {
            if (e.ctrlKey || e.metaKey || e.altKey) return
            const target = e.target
            const tag = target && target.tagName
            if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') return
            if (target && target.isContentEditable) return
            if (typeof e.key !== 'string' || e.key.length !== 1) return

            const slug = shortcutMap.get(e.key.toLowerCase())
            if (!slug) return

            const menuTargetIndex = (contextShow && contextData.showDelete && typeof contextData.beatIndex === 'number') ? contextData.beatIndex : null
            const targetIndex = menuTargetIndex ?? (typeof lastModifiedBeatIndex === 'number' ? lastModifiedBeatIndex : null)
            if (targetIndex === null) return

            e.preventDefault()
            dispatch(addBeat({ type: slug, beatIndex: targetIndex }))
            if (menuTargetIndex !== null) {
                dispatch(updateContext({
                    show: false,
                    data: { top: 0, left: 0, showDelete: false, beatIndex: 0 },
                }))
                dispatch(updateMouse({
                    mousedown: false,
                    mouseDownOnBeat: false,
                    mouseDownOnBeatType: null,
                    posX: null,
                    posY: null,
                    iStart: null,
                    bStart: null,
                    dragging: null,
                }))
            }
        }

        window.addEventListener('keydown', handleKeyDown)
        return () => window.removeEventListener('keydown', handleKeyDown)
    }, [beatLabels, contextShow, contextData.showDelete, contextData.beatIndex, lastModifiedBeatIndex, dispatch])

    useEffect(() => {
        // Total scaled drawing extent — canvas backing store, grid, and waveform
        // must all agree on this so nothing is clipped at high magnification.
        // Use max(CanvasHeight, RecordingHeightPx) as the base so short recordings
        // still clear/repaint the full canvas area (no stale pixels below the
        // waveform on zoom/lead changes).
        const ScaledWidthPx = CanvasWidth * settings.scale
        const ScaledHeightPx = Math.max(CanvasHeight, RecordingHeightPx) * settings.scale

        canvasBlurFix(ScaledWidthPx, ScaledHeightPx)

        const annotatorCanvas = document.getElementById('waveCanvas');

        const context = annotatorCanvas.getContext('2d');
        context.clearRect(0, 0, ScaledWidthPx, ScaledHeightPx);

        paintGrid(context, SecondsPerRow, ScaledHeightPx, ScaledWidthPx, settings.scale);
        paintSingleLeadWaveform(
            CurrentSample,
            RowHeightPx * settings.scale,
            context,
            settings.scale,
            SamplePerRow,
            RowWidthPx,
            NoOfRows,
            Annotator.filtered.gain * 2.5
        );
    }, [PageRendered, windowSize, Annotator.selectedLead, settings.scale, inverted, samples, Annotator.filtered.frequency, Annotator.filtered.gain])

    const EtoSampleIndex = (e) => {
        const [x,y] = eventCoordinate(e)
        const ScaledRowHeightPx = RowHeightPx * settings.scale
        const currentRow = Math.floor(y/ScaledRowHeightPx)
        const YScale = yScale(ScaledRowHeightPx, settings.scale, Annotator.filtered.gain * 2.5); // This function returns the Y coordinate adjusted to the scale provided a value
        const XScale = xScale(SamplePerRow, CanvasWidth, settings.scale) // This function returns the X coordinate adjusted to the scale provided a value
        const iFromLeft = Math.floor(XScale.invert(x))
        const iFromTop = SamplePerRow * currentRow
        return iFromLeft+iFromTop
    }

    const SampleIndextoPx = (i) => {
      let XCoordinate, YCoordinate

      const currentRow = Math.floor(i/SamplePerRow)
      const sampleFromLeft = i - currentRow * SamplePerRow // Generate X coordinate using this
      // Match the waveform's coordinate system: rows are drawn at RowHeightPx * scale
      // spacing, and each row's x extent is CanvasWidth * scale.
      const ScaledRowHeightPx = RowHeightPx * settings.scale
      const YScale = yScale(ScaledRowHeightPx, settings.scale, Annotator.filtered.gain * 2.5); // This function returns the Y coordinate adjusted to the scale provided a value
      const XScale = xScale(SamplePerRow, CanvasWidth, settings.scale) // This function returns the X coordinate adjusted to the scale provided a value
      const OffsetHeight = currentRow * ScaledRowHeightPx // 0 line of every row
      XCoordinate = XScale(sampleFromLeft)
      YCoordinate = YScale(CurrentSample[i]) + OffsetHeight
      return [XCoordinate,YCoordinate]
    }

    const getIntrXYs = (a,b) => {
        let x1,x2,y1,y2
        const start = a > b ? b : a
        const end =  a > b ? a : b
        const currentStartRow = Math.floor(start/SamplePerRow)
        const currentEndRow = Math.floor(end/SamplePerRow)
        const ScaledRowHeightPx = RowHeightPx * settings.scale

        // X values
        const sampleFromLeftStart = start - currentStartRow * SamplePerRow
        const sampleFromLeftEnd = end - currentEndRow * SamplePerRow
        const XScale = xScale(SamplePerRow, CanvasWidth, settings.scale)
        x1=XScale(sampleFromLeftStart)
        x2=XScale(sampleFromLeftEnd)

        // Y values
        y1= currentStartRow*ScaledRowHeightPx
        y2= (currentEndRow+1)*ScaledRowHeightPx

        return [x1,y1,x2,y2]
    }

    const multiRowIntervalCalculator = (coordinates) => {
        const [x,y,x2,y2] = coordinates
        const rw = CanvasWidth * settings.scale
        const rh = Lib.MV_BANDWIDTH * Lib.PX_PER_MV * 2 * settings.scale
        let data=[]
        const startRow = y/rh
        const endRow = y2/rh
        data.push([x,y,rw,y+rh])
        for(let i = startRow; i<endRow-1; i ++){
            data.push([0,rh*(i+1),rw,rh*(i+2)])
        }
        data[data.length-1][2]=x2
        return data
    }

    const BeatPlotPeakDetection = (sampleIndex, clickY) => {
        const currentRow = Math.floor(sampleIndex / SamplePerRow)
        const ScaledRowHeightPx = RowHeightPx * settings.scale
        const yCoordInRow = clickY - ( currentRow * ScaledRowHeightPx)
        const yClickScale = yScale(ScaledRowHeightPx, settings.scale, Annotator.filtered.gain * 2.5)
        const yAmp = yClickScale.invert(yCoordInRow)

        const peak = searchForLocalPeak(sampleIndex, yAmp, CurrentSample, Annotator.filtered.frequency)

        const y = yClickScale(peak.sampleData);
        const newOffset = peak.index - SamplePerRow * currentRow;
        const x = xScale(SamplePerRow, CanvasWidth, settings.scale)(newOffset);
        return {
            x: x,
            y: y,
            index: peak.index,
            offset: newOffset,
        };
    };

    const rangeIntersection = (a,b) => {
        // const {start:r1s, end:r1e} = a
        // const {start:r2s, end:r2e} = b
        // const [r1s,r1e] = [r1.start,r1.end]
        // const [r2s,r2e] = [r2.start,r2.end]
        // console.log(r1s,r1e);
        // console.log(r2s,r2e);    
        const min = (a.start < b.start  ? a : b)
        const max = (min == a ? b : a)
    
        //min ends before max starts -> no intersection
        if(min.end < max.start)
            return null //the ranges don't intersect

        //  Generates the sumed up intervals
        return [ (min.start < max.start ? min.start : max.start) , (min.end > max.end ? min.end : max.end)]
    }

    const SampleIndextoTime = (i) => {
        if (!Number.isFinite(i)) return "0.00"
        const timeScale = xScale(CurrentSampleLength,TotalSeconds,1)
        const t = timeScale(i)
        return Number.isFinite(t) ? t.toFixed(2) : "0.00"
    }

    const sort2D = (a, b) => {
        if (a[0] === b[0]) {
            return 0;
        }
        else {
            return (a[0] < b[0]) ? -1 : 1;
        }
    }

    // Mouse Constants 
    const GhostData = useSelector(state => state.Annotator.ghostBeat)
    const ShowGhost = useSelector(state => state.Annotator.ghostBeat.show)
    const GhostIntrData = useSelector(state => state.Annotator.interval)
    const ShowIntrGhost = useSelector(state => state.Annotator.interval.show)
    const Mouse = useSelector(state => state.Annotator.mouse)
    const deleting = useSelector(state => state.Annotator.context.data.showDelete)

    //   Mouse Event Handling   
    const Actions = {
      MOVE_BEAT : 'move_beat',
    }
    const MouseHandler = (e) => {
        // mousedown - Mouse Click
        // mousemove - Mouse Drag
        // mouseup - Mouse leave Click
        // Click - Mouse Left Click
        // contextmenu - Mouse Right Click
        e.stopPropagation();
        e.preventDefault()
        const [x,y,pageX,pageY]=eventCoordinate(e)
        let index
        index = BeatPlotPeakDetection(EtoSampleIndex(e), y).index
        // index = EtoSampleIndex(e)
        const [bx,by] = SampleIndextoPx(index)
        if(!isCompleted)
        switch(e.type){
            case "mousedown":
                if(e.button == 0 ){ // If Left Click
                    dispatch(updateMouse({
                        mousedown: true,
                        posX : bx,
                        posY : by,
                        iStart: index,
                    }))
                    dispatch(updateContext({
                        show : false,
                        data : {
                            top:0,
                            left:0,
                            showDelete:false,
                            beatIndex:0,
                        }
                    }))
                    // check if interval context menu is open
                    if(ShowIntervalContext){
                        dispatch(updateIntrContext({
                            show : false,
                        }))
                    }
                }
                // if(e.button == 2){ //Right Click
                //     //console.log("Mouse Right click ",x,y)
                // } Currently being handled using Context menu event 
                break
            case "mousemove":
                if(Mouse.mousedown && !ShowIntervalContext){ // If Mouse is in clicked state
                    if(Mouse.mouseDownOnBeat){ // If mouse is on top of a beat 
                        //console.log("==== Draging a beat ====")
                        dispatch(updateGhostBeat({
                            show : true,
                            coordinates : [bx,by],
                        }))
                    } else {
                        //console.log("==== Creating an interval ====")
                        dispatch(updateGhostIntr({
                            show : true,
                            coordinates : getIntrXYs(Mouse.iStart,index),
                        }))
                    }
                }
                break
            case "mouseup":
                if(Mouse.mousedown){
                    if(Mouse.iStart != index){ //if mouse has been dragged
                    if(Mouse.mouseDownOnBeat){ // if it was on a beat
                        //console.log("Beat at ",Mouse.bStart," moved to ",EtoSampleIndex(e))
                        
                        if( e.button != 2 ){ // if it was not a right click
                        dispatch(modifyBeat({beatIndex:Mouse.bStart,newValue:[index,Mouse.mouseDownOnBeatType]}))
                        }
                    } else {
                        // ============= Interval Creation Block =============
                        //console.log("Interval created from ",Mouse.iStart," to ",EtoSampleIndex(e))
                        let IntervalPayload = {
                            start:Mouse.iStart < index ? Mouse.iStart : index,     // Start "i" value
                            end:Mouse.iStart > index ? Mouse.iStart : index,       // End "i" value
                            time:{
                                // start:SampleIndextoTime(Mouse.Start),i          // start time in seconds
                                // end:SampleIndextoTime(index),                   // end time in seconds
                            },
                            type: {
                                id:'',                                             // type id from backed
                                name:'',                                           // type name from backend
                            },
                            // position:getIntrXYs(Mouse.iStart,index),            // this is the start and end coordinated in the graph. WILL BE REMOVED DOWN THE LANE
                            bpm:69, // BPM for the interval
                        }

                        // ============= Checking to See if altering intervals are required =============
                        let alterIntr = false
                        let alterIntrIndex = []
                        Annotator.annotations.intervals.map(intr => {
                            let newIntr = rangeIntersection(intr,IntervalPayload)
                            if(newIntr){
                                alterIntr=true
                                alterIntrIndex.push(intr.start)
                                IntervalPayload.start=newIntr[0]
                                IntervalPayload.end=newIntr[1]
                            }
                        })
                        if(alterIntr) alterIntrIndex.map(i=>dispatch(removeIntr(i)))
                        // ============= ============= ============= =============

                        // ============= Generating position & time meta data =============
                        IntervalPayload.position=getIntrXYs(IntervalPayload.start,IntervalPayload.end)
                        IntervalPayload.time.start = SampleIndextoTime(IntervalPayload.start)
                        IntervalPayload.time.end = SampleIndextoTime(IntervalPayload.end)
                        // ============= ============= ============= =============

                        // ============= BPM Calculations for the new interval =============
                        const beatlist = Annotator.annotations.beats.filter(b=> b.i>IntervalPayload.start && b.i<IntervalPayload.end)
                        let bpmArray = []
                        //console.log("<===BPM===>")
                        //console.log("Found ",beatlist.length," beats");
                        beatlist.sort(sort2D)
                        for(let i =0; i<beatlist.length-1;i++){
                            if((beatlist[i].t   == "n") && (beatlist[i+1].t == "n") ){
                                bpmArray.push(Math.round(60/(Math.abs(beatlist[i].i-beatlist[i+1].i)/Annotator.filtered.frequency)))
                                console.log(`%c+ Beats ${beatlist[i].i} and ${beatlist[i+1].i} type: ${beatlist[i].t},${beatlist[i+1].t}`, 'color: #5FA777')
                            } else {
                                console.log(`%c- Beats ${beatlist[i].i} and ${beatlist[i+1].i} type: ${beatlist[i].t},${beatlist[i+1].t}`, 'color: #FF6962')
                            }
                        }
                        IntervalPayload.LeadData = Annotator.selectedLead
                        IntervalPayload.beatCount = beatlist.length
                        //console.log("BPM Array => ",bpmArray);
                        const sum = bpmArray.reduce((a, b) => a + b, 0);
                        const avg = (sum / bpmArray.length) || 0;
                        if(bpmArray.length > 0){
                        IntervalPayload.bpm={
                            min:Math.min(...bpmArray).toFixed(0),
                            max:Math.max(...bpmArray).toFixed(0),
                            average:avg.toFixed(0)
                        }}
                        else{
                            IntervalPayload.bpm = null
                        }
                        //console.log("BPM set: ",IntervalPayload.bpm)
                        // ============= ============= ============= =============

                        // ============= Finally Adding Interval =============
                        if(IntervalPayload.end-IntervalPayload.start > 75)dispatch(addIntr(IntervalPayload))
                        // ============= ============= ============= =============

                        // ============= Action completed - Reset all the state =============
                        dispatch(updateMouse({
                            mousedown : false,
                            mouseDownOnBeat : false,
                            mouseDownOnBeatType : null,
                            posX : null,
                            posY : null,
                            iStart : null,
                            bStart : null,
                            dragging: null,
                        }))
                        // RESET GHOST
                        dispatch(updateGhostBeat({
                            show : false,
                        }))
                        // RESET GHOST 
                        dispatch(updateGhostIntr({
                            show : false,
                        }))
                    }}
                    // RESET MOUSE
                    dispatch(updateMouse({
                        mousedown : false,
                        mouseDownOnBeat : false,
                        mouseDownOnBeatType : null,
                        posX : null,
                        posY : null,
                        iStart : null,
                        bStart : null,
                        dragging: null,
                    }))
                    // RESET GHOST
                    dispatch(updateGhostBeat({
                        show : false,
                    }))
                }
                break
            case "contextmenu":
                if(!deleting){ // if the beat deleting didnt not invoke this event ( thats handled on the beats component)
                    // Auto-classify as normal on right-click. User right-clicks the placed beat to reclassify.
                    dispatch(addBeat({type: "n", beatIndex: index}))
                    // RESET MOUSE
                    dispatch(updateMouse({
                        mousedown : false,
                        mouseDownOnBeat : false,
                        mouseDownOnBeatType : null,
                        posX : null,
                        posY : null,
                        iStart : null,
                        bStart : null,
                        dragging: null,
                    }))
                }
                break
            default:
                //console.log("Warning: Unhandled Mouse Event - ",e.type)
                break
        }
    }

    return (
        <div className={styles.AnnotatorContainer} style={{minHeight: `${MinContainerHeightPx + 70}px`, minWidth: `${MinContainerWidthPx}px`}}>
            <div className={styles.AnnotatorHeader}>
                <Card sx={{width: "100%", display: "flex"}}>
                    <button className={styles.goBackButton} onClick={()=>onDeSelectLead()}> 
                        <ChevronLeftIcon />
                        &nbsp;&nbsp;
                        Go back
                    </button>
                    <div className={styles.CenterSection}>
						<Divider orientation="vertical" sx={{marginRight: "20px"}} />
                        <FormControl sx={{width: "300px" }}  size="small">
                            <InputLabel id="lead-select-label">ECG Leads</InputLabel>
                            <Select
                                labelId="lead-select-label"
                                id="lead-select"
                                label="ECG Leads"
                                onChange={(e) => dispatch(selectLead(e.target.value))}
                                value={Annotator.selectedLead}
                            >
                                {Object.keys(samples).map((lead) => (
                                    <MenuItem key={lead} value={lead}>Lead {lead}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
						<Divider orientation="vertical" sx={{marginX: "20px"}} />
                            <span className={styles.Leadname}>{Annotator.filtered.duration}s</span>
						<Divider orientation="vertical" sx={{marginRight: "20px"}} />
                            <span className={styles.Leadname}>{Annotator.leadCount}L ECG</span>
						<Divider orientation="vertical" sx={{marginRight: "20px"}} />
                    </div>
                    <div  className={styles.ScaleDiv}>
						<Divider orientation="vertical" sx={{marginRight: "20px"}} />
                        <h4 className={styles.ScaleText}>25 mm/s &nbsp; 10 mm/mV</h4>
                    </div>

                </Card>
            </div>
            <Card ref={AnnotatorContainer} className={styles.AnnotatorTool}
                onMouseMove={MouseHandler}
                onMouseUp={MouseHandler}
                onMouseDown={MouseHandler}
                onClick={MouseHandler}
                onContextMenu={MouseHandler}
            >
                <canvas
                    className={styles.canvas}
                    id="waveCanvas"
                    height={Math.max(Height, ScaledContentHeightPx)}
                    width={Math.max(Width, ScaledContentWidthPx)}
                    ref={AnnotatorCanvas}
                    // onMouseDown={(e) => mouseDown(e)}
                    // onMouseMove={(e) => mouseOver(e)}
                    // onMouseUp={(e) => mouseUp(e)}
                    // onContextMenu={(e) => contextMenu(e)}
                    >
                </canvas>
                <svg width={Math.max(Width, ScaledContentWidthPx)} height={Math.max(Height, ScaledContentHeightPx)} className={styles.topSVG}>
                  {PageRendered && Annotator.annotations.intervals && Annotator.annotations.intervals.map(intr => {
                    const scaledCoords = getIntrXYs(intr.start, intr.end)
                    if (!scaledCoords.every(Number.isFinite)) return null
                    return (
                    <Interval
                        coordinates ={scaledCoords}
                        data = {multiRowIntervalCalculator(scaledCoords)}
                        type ={intr.type}
                        index ={intr.start}
                        interval = {intr}
                        key ={JSON.stringify(intr)}
                    />
                    )
                  })}
                  {PageRendered && ShowIntrGhost && GhostIntrData["coordinates"].every(Number.isFinite) &&
                    <Interval
                        coordinates ={GhostIntrData["coordinates"]}
                        type ={{name:"ghost"}}
                        index ={GhostIntrData["index"]}
                        data = {multiRowIntervalCalculator(GhostIntrData["coordinates"])}
                    />
                  }
                  {/* { === Interval done === } */}
                  {PageRendered && Annotator.annotations.beats && Annotator.annotations.beats != [] && Annotator.annotations.beats.map(beat => 
                    <Beat 
                        coordinates={SampleIndextoPx(beat.i)}
                        type={beat.t}
                        index={beat.i}
                        key ={beat.i}
                        beatLabel={Annotator.annotations.labels.beats}
                    />
                  )}
                  {PageRendered && ShowGhost &&
                    <Beat 
                        coordinates ={GhostData["coordinates"]}
                        type ={"ddf"}
                        index ={GhostData["index"]}
                        beatLabel={Annotator.annotations.labels.beats}
                    />
                  }
                </svg>
            </Card>
            { ShowContext && 
                <ContextMenu 
                    beatLabel={Annotator.annotations.labels.beats}
                />
            }
            { ShowIntervalContext && 
                <IntervalContextMenu />
            }
        </div>
        
    )
}

export default SingleLeadView
